import React, { useState } from 'react';
import styled from 'styled-components';
import {
  offset,
  shift,
  useClick,
  useDismiss,
  useFloating,
  useInteractions,
  useRole,
} from '@floating-ui/react';
import { IEntityPermissionFieldsFragment } from '../../../utils/apollo/graphqlSchema';
import { FloatingLayer } from '../../FloatingManager';
import { PrimaryButton } from '../../Button';
import KubitTooltip from '../../KubitTooltip';
import { SvgIcon } from '../../Icon';
import ScratchpadEntityPermissionsWidgetPopover from './ScratchpadEntityPermissionsWidgetPopover';
interface IProps {
  permission: IEntityPermissionFieldsFragment;
  scratchpadId: string;
}

const StyledPrimaryButton = styled(PrimaryButton)`
  align-items: center;
  width: 24px;
  height: 24px;
  min-width: unset;
  padding: 0;
  border: 0;
`;

const ShareScratchpadPermissionsWidget = ({
  permission,
  scratchpadId,
}: IProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const { refs, floatingStyles, context } = useFloating({
    open: isOpen,
    onOpenChange: setIsOpen,
    middleware: [offset(5), shift()],
    placement: 'bottom-end',
  });

  const click = useClick(context);
  const dismiss = useDismiss(context, {
    ancestorScroll: true,
  });
  const role = useRole(context);

  const { getReferenceProps, getFloatingProps } = useInteractions([
    click,
    dismiss,
    role,
  ]);

  return (
    <>
      <KubitTooltip
        content={'Share with collaborators'}
        placement="bottom-end"
        disabled={isOpen}
      >
        <StyledPrimaryButton ref={refs.setReference} {...getReferenceProps()}>
          <SvgIcon
            name="share-network"
            width={16}
            height={16}
            customFill="currentColor"
          />
        </StyledPrimaryButton>
      </KubitTooltip>
      {isOpen && (
        <FloatingLayer>
          <div
            ref={refs.setFloating}
            style={floatingStyles}
            {...getFloatingProps()}
          >
            <ScratchpadEntityPermissionsWidgetPopover
              scratchpadId={scratchpadId}
              permission={permission}
            />
          </div>
        </FloatingLayer>
      )}
    </>
  );
};

export default ShareScratchpadPermissionsWidget;
